<script>
import { authComputed } from "@/store/helpers";

export default {
  computed: {
    ...authComputed,
  },
  name: "FooterBar",
};
</script>

<template>
  <div class="footer">
    <h6>Copyright 2023 © by L. Alic</h6>
    <router-link v-if="!loggedIn" to="/login" class="button buttonHide no-underline">
      Login
    </router-link>
  </div>
</template>

<style scoped lang="less"></style>
